import MuiDialog from 'components/MuiDialog';
import { Typography, Grid } from '@mui/material';
import { useForm } from 'react-hook-form';
import {
  SurveyDialogProps,
  TPersonalInfoAgreement,
} from 'routes/Main/Survey/type';
import useSurvey from 'store/survey/useSurvey';
import useNotification from 'hooks/useNotification';
import Signature from './Signature';
import ConsentForm from './ConsentForm';
import { getPiiAgreement, updatePiiAgreement } from 'apis/survey';
import { useState, useEffect, useCallback } from 'react';

const PersonalAgreement = (
  props: SurveyDialogProps<TPersonalInfoAgreement>
) => {
  const {
    title,
    isOpen,
    disabled,
    defaultValues,
    user_id,
    nurseName,
    patientInfo,
    onClose,
  } = props;
  const [agreementInfo, setAgreementInfo] = useState<any>();
  const { onUpdateIsSave } = useSurvey();
  const { onSuccess, onFail, onResultCode, onRequired } = useNotification();

  const { handleSubmit, register, getValues, setValue, watch, control, reset } =
    useForm({
      defaultValues,
    });

  useEffect(() => {
    if (agreementInfo) {
      reset({
        pa_agreement: agreementInfo.pa_agreement,
        pa_subject_name: agreementInfo.pa_subject_name,
        pa_date: agreementInfo.pa_date,
        pa_student_number: agreementInfo.pa_student_number,
        pa_name: agreementInfo.pa_name,
        pa_signature: agreementInfo.pa_signature,
      });
    }
  }, [agreementInfo, reset]);

  const onSubmit = (data: any) => {
    const request = {
      user_id,
      patient_id: patientInfo.patient_id,
      piiCollectionAgreementInfo: { ...data },
    };
    updatePiiAgreement(request)
      .then(({ data: { rc } }) => {
        if (rc !== 1) {
          onResultCode(rc);
        } else {
          onUpdateIsSave(true);
          onSuccess('저장되었습니다');
        }
      })
      .catch(e => onFail('저장에 실패하였습니다', e));
  };

  const formProps = {
    disabled,
    watch,
    getValues,
    setValue,
    onSuccess,
    onRequired,
    register,
    agreementInfo,
    control,
  };

  // TODO
  const onGetAgreement = useCallback(() => {
    getPiiAgreement({
      patient_id: String(patientInfo.patient_id),
      user_id,
    })
      .then(({ data }) => {
        setAgreementInfo(data.pii_collection_agreement_info);
      })
      .catch((e: any) => {
        const message = `동의서 정보를 호출하는데 실패했습니다.`;
        onFail(message, e);
      });
  }, []);

  useEffect(onGetAgreement, [onGetAgreement]);

  return (
    <MuiDialog.SurveyForm
      title={title}
      isOpen={isOpen}
      onClose={onClose}
      onSubmit={disabled ? undefined : handleSubmit(onSubmit)}
      update_at={defaultValues?.update_at}
    >
      <Grid
        container
        wrap="wrap"
        rowSpacing={5}
        columnSpacing={3}
        sx={{ py: 5, px: 1 }}
      >
        <Typography
          sx={{
            margin: '40px auto 0px auto',
            fontWeight: '700',
            fontSize: '16px',
            textAlign: 'center',
            userSelect: 'none',
          }}
        >
          개인정보 수집 이용 및 제3자 제공 동의서
        </Typography>
        <ConsentForm {...formProps} />
        <Signature {...formProps} />
      </Grid>
      <div style={{ width: '100%' }}>
        <span
          style={{
            color: '#14855B',
            float: 'right',
            marginTop: '10px',
            fontSize: '12px',
          }}
        >
          *해당 기록지는 삼육대학교 간호학과 협조를 통해 제작한 기록지입니다.
        </span>
      </div>
    </MuiDialog.SurveyForm>
  );
};

export default PersonalAgreement;
